module.exports = __webpack_public_path__ + "static/media/purchase.b4580f97.svg";